import {inject, customAttribute, DOM, bindable, bindingMode} from 'aurelia-framework';
import {noop, debounce} from 'lodash';

@inject(DOM.Element)
@customAttribute('repeat-lc')
export class RepeatLifeCycle {

  static parentCallbackMap = new WeakMap();

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) attach = noop;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) detach = noop;

  @bindable({
    primaryProperty: true,
    defaultBindingMode: bindingMode.oneTime
  }) both = null;

  __targetEl: Element;
  __parentEl: HTMLElement;
  __isLast: boolean;

  constructor(element: Element) {
    this.__targetEl = element;
  }

  attached() {
    this.__parentEl = this.__targetEl.parentElement;
    if (!RepeatLifeCycle.parentCallbackMap.has(this.__parentEl)) {
      RepeatLifeCycle.parentCallbackMap.set(this.__parentEl, debounce(() => {
        this.__callProperCallback(false);
      }, 16));
    }

    if (this.__isLast) {
      this.__callProperCallback(true);
    }
  }

  detached() {
    RepeatLifeCycle.parentCallbackMap.get(this.__parentEl)();
  }

  bind(bindingContext, overridingContext) {
    if (overridingContext.$last === true) {
      this.__isLast = true;
    }
  }

  unbind() {
    if (this.__isLast) {
      this.__isLast = false;
    }
  }

  __callProperCallback(forAttach = true) {
    if (this.both) {
      this.both();
    } else if (forAttach) {
      this.attach();
    } else {
      this.detach();
    }
  }

}
